import { type ICheckboxField } from 'types/interfaces/ICheckboxField'

import './_checkboxField.scss'

const CheckboxField = ({
    id,
    label,
    checked,
    changeFn,
    customClass = ''
}: ICheckboxField) => {
    return (
        <div className={`checkboxField ${customClass}`}>
            <input
                hidden
                id={id}
                type='checkbox'
                checked={checked}
                onChange={changeFn}
            />
            <div
                onClick={changeFn}
                className={`checkboxField__box ${
                    checked ? 'checkboxField__box--selected' : ''
                }`}
            >
                <div className='checkboxField__box__check' />
            </div>
            <label htmlFor={id}>{label}</label>
        </div>
    )
}

export default CheckboxField
